import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { Carrier } from 'app/components/data/core/models/persons/carrier';

import { LocaleService } from 'app/components/locale/locale.service';
import { carrier } from '../../../locale/locale';
import { CloudExecutor } from 'app/components/data/cloud-executors/cloud-executor';
import * as FormHelper from 'app/components/form-helper/form-helper';

@Component({
    selector   : 'carrier-create-dialog',
    templateUrl: './carrier-create-dialog.component.html',
    styleUrls  : ['./carrier-create-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class CarrierCreateDialog {

  public form: UntypedFormGroup;
  private object: Carrier;

  public title: string;
  public buttonName: string;

  public dataSaver = new CloudExecutor();

  selectedColor;

  constructor (
    public dialogRef: MatDialogRef<CarrierCreateDialog>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _formBuilder: UntypedFormBuilder,
    private localeService: LocaleService
  ) {
    this.localeService.loadLocale(carrier);
    this.object = this._data.object;

    if (this._data.action === 'create') {
        this.title = 'DIALOG.CARRIER.TITLE.CREATE';
        this.buttonName = 'DIALOG.CARRIER.CONFIRMBUTTON.CREATE';
    } else if (this._data.action === 'edit') {
        this.title = 'DIALOG.CARRIER.TITLE.EDIT';
        this.buttonName = 'DIALOG.CARRIER.CONFIRMBUTTON.SAVE';
    }

    if (this.object == null) {
      this.object = new Carrier();
    }
    this.form = this.createContactForm();
    let markColor = this.object.getMarkColor();
    this.selectedColor = markColor ? markColor : "#7daeea";
  }

  createContactForm(): UntypedFormGroup {
    let formGroup = {
      name: [this.object.getName()],
    };
    return this._formBuilder.group(formGroup);
  }

  checkAndSave() {
    if (this.checkForm()) {
      this.object.setName(this.form.get('name').value);
      this.object.setMarkColor(this.selectedColor);
      this.dataSaver.saveObject(this.object).then(obj => {
        this.dialogRef.close(obj);
      });
    }
  }

  checkForm(): boolean {
    return FormHelper.checkForm(this.form);
  }
}
